import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Grid } from '@mui/material'
import { DatePicker } from '@e3dc-react/shell/Elements/InputFields'
import moment from '@e3dc-react/shell/Libs/moment'
import { useFormikContext } from 'formik'
import { ExportChargingCardFormData } from './ExportChargingCardEditor'

interface ExportChargingCardMonthYearTabProps {
  field: 'month' | 'year'
}

const ExportChargingCardMonthYearTab: React.FC<ExportChargingCardMonthYearTabProps> = ({ field }): JSX.Element => {
  const { t } = useCustomTranslation()
  const { setFieldValue, values, errors } = useFormikContext<ExportChargingCardFormData>()

  return (
    <Grid container paddingY={2}>
      <Grid item xs={6}>
        <DatePicker
          helperText={field === 'month' ? errors.month : errors.year}
          value={field === 'month' ? moment(values.month) : moment(values.year)}
          views={field === 'month' ? ['year', field] : [field]}
          label={t(`emobility.chargingCards.export.${field}`)}
          format={field === 'month' ? t('emobility.chargingCards.export.formatMonth') : t('emobility.chargingCards.export.formatYear')}
          onChange={value => setFieldValue(field, value ? value.toDate() : null)}
          clearable={false}
        />
      </Grid>
    </Grid>
  )
}

export default ExportChargingCardMonthYearTab
